import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { CustomAdvancedMenuList, StyledDataGrid } from '../../../components/StyledComponents'
import { ClickAwayListener, Grow, LinearProgress, MenuItem, Paper, Popper } from '@mui/material'
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay'
import AddBoxIcon from '@mui/icons-material/AddBox';
import { ControlpanelPrimaryButton, ControlpanelSuccess2thButton } from '../../../components/StyledButton';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyIcon16pxSvg from './../../../assets/images/icons/KeyIcon16pxSvg';
import { Link } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid';
import CustomPagination from '../CustomPagination';
import CustomGridToolbarQuickFilter from '../CustomGridToolbarQuickFilter';
import { useTranslation } from 'react-i18next';
import DevicesData from '../../../assets/data/DevicesData';
import GenerateANewDeviceRegistrationTokenDialog from './GenerateANewDeviceRegistrationTokenDialog';
import ApiCredentialsDialog from './ApiCredentialsDialog';
import { toast } from 'react-toastify';
import DeviceApi from '../../../axios/Device/DeviceApi';
import { useSettings } from '../../../context/SettingsContext';
import { format } from 'date-fns';
import { formatDateTimeString } from '../../../utils/FormatDateTimeString/dateUtils';
import Cookies from "js-cookie";
import { useAuth } from '../../../context/AuthContext';
import RegistersDeviceDialog from './RegistersDeviceDialog';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import { useLoading } from '../../../context/LoadingContext';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';

const MODE = {
    none: -1,
    import: 0,
    export: 1,
    delete: 2,
    invite: 3,
    create: 4,
    createFromDelete: 5,
    advanced: 6,
};
const DevicesGridInfoTable = ({
    onRowClick,
    onRowDoubleClick,
    onRowSelection,
    refreshData,
    setLoading,
    onRefresh,
    GroupData,
    usersData
}) => {
    const { genaralSettingDateFormat, genaralSettingTimeFormat, dateTimeFormat } = useAuth();
    const { t, i18n } = useTranslation()
    const { getDeviceList } = DeviceApi()
    const [mode, setMode] = useState(MODE.none);
    const anchorRefAdvanced = useRef(null);
    const currentLang = i18n.language;
    const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
    const [openRegisterDevice, setOpenRegisterDevice] = useState(false)
    const [activeStatus, setActiveStatus] = useState()
    const { settings } = useSettings();
    const { profile } = useAuth();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const handleOpenRegisterDevice = () => {
        setActiveStatus("begin")
        setOpenRegisterDevice(true);
    };

    const handleCloseRegisterDevice = () => {
        setOpenRegisterDevice(false);
    };

    const [show, hide] = useLoading()

    const formatDateTime = (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        return format(date, `${settings.dateFormat} ${settings.timeFormat}`);
    };

    const renderEmpty = (value) => {
        return value !== null &&
            value !== undefined &&
            value !== ""
            ? value
            : "-";
    };

    const columnData = [
        {
            field: 'id',
            headerName: 'ID',
            minWidth: 100,
            renderCell: (params) => renderEmpty(params.value),
        },
        {
            field: 'indetifier',
            headerName: t('common.device-sn'),
            flex: 1,
            renderCell: (params) => renderEmpty(params.value),
        },
        {
            field: 'deviceName',
            headerName: t('common.device-name'),
            flex: 1,
            renderCell: (params) => renderEmpty(params.value),
        },
        {
            field: 'deviceType',
            headerName: t('common.type'),
            flex: 1,
            renderCell: (params) => {
                const type = params?.value;

                if (!type) return "-";

                if (type === 'COMPANY/GROUP') {
                    return t('common.company-group');
                }

                if (type === 'MOBILE') {
                    return t('common.mobile');
                }

                return type;
            }
        },
        {
            field: 'companyName',
            headerName: t('common.company'),
            flex: 1,
            renderCell: (params) => renderEmpty(params.value),
        },
        {
            field: 'fullName',
            headerName: t('common.content-125'),
            flex: 1,
            renderCell: (params) => renderEmpty(params.value),
        }
    ];

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        description: true,
        // application: true,
        blocked: true,
        // lastAccess: true,
        // lastUpdated: true,
        assignedTo: true,
        // licensed: true,
        createdTime: true
    });
    const emailUser = profile?.email;
    const handleColumnVisibilityChange = (newModel) => {
        setColumnVisibilityModel(newModel);
        Cookies.set(`DevicesGridInfoTable_${emailUser}`, JSON.stringify(newModel), {
            expires: 90,
            path: "/",
        });
    };

    useEffect(() => {
        const saved = Cookies.get(`DevicesGridInfoTable_${emailUser}`);
        if (saved) {
            setColumnVisibilityModel(JSON.parse(saved));
        }
    }, []);

    const [selectedRowId, setSelectedRowId] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [gridLoading, setGridLoading] = useState(false)
    const [totalPages, setTotalPages] = useState(1);
    const [rowCount, setRowCount] = useState(0)
    const [filteredRowData, setFilteredRowData] = useState([]);
    const [filteredRowCount, setFilteredRowCount] = useState(0);

    const fetchData = async () => {
        show();
        try {
            const response = await getDeviceList(
                {
                    pageNo: page + 1,
                    recordPerPage: pageSize
                },
                localStorage.getItem("i18nextLngId")
            )
            if (response.data.message === "Successful" || response.data.message === "Thành công") {
                setTotalPages(response.data?.pagination?.totalPages);
                setRowCount(response.data?.pagination?.totalElements);
                const dataWithId = response.data.data;
                setRowData(dataWithId);

                setFilteredRowData(response.data.data);
                setFilteredRowCount(response.data?.pagination?.totalElements);
                onRowClick(dataWithId[0]);

                if (dataWithId.length > 0) {
                    const firstRow = dataWithId[0];
                    setSelectedRowId(firstRow.id);
                    onRowSelection(prevSelectedRows => ({
                        ...prevSelectedRows,
                        companyName: firstRow.companyName,
                        deviceType: firstRow.deviceType,
                        fullName: firstRow.fullName,
                        groupId: firstRow.groupId,
                        groupName: firstRow.groupName,
                        id: firstRow.id,
                        indetifier: firstRow.indetifier,
                        userId: firstRow.userId,
                    }));
                }
                hide()
            }

        } catch (error) {
            hide();
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error('Error fetching data')
                }
            } else {
                // toast.error('Network error or server is unreachable');
            }
            console.error('Error fetching data:', error);
        } finally {
            hide()
        }
    };

    useEffect(() => {
        show()
        const timeoutId = setTimeout(() => {
            fetchData();
            hide()
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [page, pageSize, refreshData]);

    const handleRowClick = (params) => {
        const rowData = params.row;
        if (rowData) {
            onRowClick(rowData);
        }
    };

    const onRowsSelectionHandler = (newSelection) => {
        const selectedRow = rowData.find(row => row.id === newSelection[0]);

        if (selectedRow) {
            onRowSelection({
                id: selectedRow.id,
                indetifier: selectedRow.indetifier,
                deviceType: selectedRow.deviceType,
                companyName: selectedRow.companyName,
                groupName: selectedRow.groupName,
                userId: selectedRow.userId,
                groupId: selectedRow.groupId
            });
        }
    };

    const handleCloseDialog = () => {
        setMode(MODE.none);
    };

    const handleQuickFilterChange = (searchText) => {
        const lowerSearch = searchText.toLowerCase();
        const filtered = rowData.filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(lowerSearch)
            )
        );
        setFilteredRowData(filtered);
    };

    const toolbarContent = useCallback(
        () => (
            <div className='flex justify-between items-center mb-2'>
                <div className='flex gap-3'>
                    {/* <ControlpanelSuccess2thButton onClick={handleOpenRegisterDevice} style={{ display: 'none' }}>
                        <AddBoxIcon />
                        <p>{t('common.registers-device')}</p>
                    </ControlpanelSuccess2thButton> */}

                    <ControlpanelPrimaryButton
                        disableRipple
                        onClick={() => setMode(MODE.advanced)}
                        ref={anchorRefAdvanced}
                        id='advanced-button'
                        aria-haspopup='true'
                        style={{ opacity: '0.5', pointerEvents: 'none' }}
                    >
                        <SettingsIcon />
                        <p>{t('button.advanced')}</p>
                        <ArrowDropDownIcon />
                    </ControlpanelPrimaryButton>

                </div>
                <CustomGridToolbarQuickFilter onSearchChange={handleQuickFilterChange} />
            </div>
        ),
        [t, anchorRefAdvanced]
    );

    const handleRowsPerPageChange = (newPageSize) => {
        const size =
            typeof newPageSize === "number"
                ? newPageSize
                : parseInt(newPageSize.target.value, 10);

        // reset luôn về page 0
        setPage(0);

        setPageSize(size);
    };

    return (
        <div className="h-full min-h-0">
            <StyledDataGrid
                sx={{
                    height: "100% !important",

                    ".MuiDataGrid-main": {
                        height: "100%",
                    },

                }}
                rows={Array.isArray(rowData) ? rowData : []}
                rowCount={rowCount}
                pagination
                paginationMode="server"
                columns={columnData}
                getRowId={(row) =>
                    `${row.id}-${row.deviceType}-${row.userId ?? "nouser"}`
                }
                ignoreDiacritics
                slots={{
                    toolbar: toolbarContent,
                    pagination: CustomPagination,
                    noRowsOverlay: NoRowOverlay,
                    columnsPanel: CustomColumnsPanel,
                }}
                slotProps={{
                    pagination: {
                        page,
                        count: rowCount,
                        rowsPerPage: pageSize,
                        onPageChange: setPage,
                        onRowsPerPageChange: handleRowsPerPageChange,
                    },
                }}
                localeText={tableTranslated}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={handleColumnVisibilityChange}
                onRowSelectionModelChange={onRowsSelectionHandler}
                onRowClick={handleRowClick}
            />
            {openRegisterDevice && <RegistersDeviceDialog onClose={handleCloseRegisterDevice} GroupData={GroupData} onRefresh={onRefresh} usersData={usersData} />}
            {mode === MODE.advanced && (
                <Popper open anchorEl={anchorRefAdvanced.current} placement='bottom-start' transition disablePortal className='z-10'>
                    {({ TransitionProps, placement }) => (
                        <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom' }}>
                            <Paper style={{ borderRadius: '6px' }}>
                                <ClickAwayListener onClickAway={handleCloseDialog}>
                                    <CustomAdvancedMenuList id='advanced-menu' aria-labelledby='advanced-button'>
                                        <MenuItem style={{ borderBottom: '1px solid #E5E7EB', opacity: "0.5", pointerEvents: "none" }} onClick={() => setMode(MODE.import)} >
                                            <Link>
                                                <KeyIcon16pxSvg />
                                                <p>Generate API access credentials</p>
                                            </Link>
                                        </MenuItem>
                                        {/* <MenuItem style={{ borderBottom: '1px solid #E5E7EB', opacity: "0.5", pointerEvents: "none" }} onClick={() => setMode(MODE.export)} >
                                            <Link>
                                                <CloudArrowDownIcon16pxSvg />
                                                <p>{t('button.export-data')}</p>
                                            </Link>
                                        </MenuItem> */}
                                    </CustomAdvancedMenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            )}
        </div>
    )
}

export default DevicesGridInfoTable